import React from "react";
import HeadTitle from "components/HeadTitle";
import { PrivacyWrapper, PrivacyContent } from "../PrivacyPolicyPage/styled";

const TermsOfServicePage = () => {
  return (
    <>
      <HeadTitle title={"Foody | Terms of Service"} />
      <PrivacyWrapper>
        <PrivacyContent>
          <div>
            <p
              align="center"
              style={{
                marginLeft: "0in",
                marginRight: "0in",
                textIndent: "0in",
                lineHeight: "100%",
                orphans: 2,
                widows: 2,
              }}
            >
              <a name="_Hlk83639457" />
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>
                    Foody
                    <br />
                    Terms of Service Agreement
                    <br />
                    Last Updated: November 8, 2021
                  </b>
                </font>
              </font>
            </p>
            <p
              align="justify"
              style={{
                marginLeft: "0in",
                marginRight: "0in",
                textIndent: "0in",
                lineHeight: "100%",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  Welcome to Foody! This Terms of Service Agreement (the “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>Terms</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”) governs your use of the www.joinfoody.com website and any other website of Foody, its current and
                  future affiliates and agents, and any service, content and resources available or enabled via our
                  website (collectively the “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>Platform</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”). PLEASE READ THESE TERMS CAREFULLY. THIS AGREEMENT IS A LEGAL CONTRACT BETWEEN YOU (AS DEFINED
                  BELOW) AND FOODIE WORLDWIDE, INC. (“
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>FOODY</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ,” “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>WE</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ,” “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>US</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ” OR “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>OUR</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”).
                </font>
              </font>
            </p>
            <p
              align="justify"
              style={{
                marginLeft: "0in",
                marginRight: "0in",
                textIndent: "0in",
                lineHeight: "100%",
                orphans: 0,
                widows: 0,
              }}
            >
              <font color="#000000">
                <font face="Lato-Regular, serif">
                  <font size={2} style={{ fontSize: "9pt" }}>
                    <b>
                      SECTION 19 OF THIS AGREEMENT IS AN ARBITRATION CLAUSE THAT REQUIRES MOST DISPUTES BETWEEN US TO BE
                      RESOLVED ON AN INDIVIDUAL, NON-CLASS ACTION BASIS THROUGH BINDING AND FINAL ARBITRATION INSTEAD OF
                      IN COURT. SEE SECTION 19 FOR MORE INFORMATION REGARDING THIS ARBITRATION CLAUSE, AND HOW TO OPT
                      OUT IF YOU DESIRE TO DO SO.
                    </b>
                  </font>
                </font>
              </font>
            </p>
            <p
              align="justify"
              style={{
                marginLeft: "0in",
                marginRight: "0in",
                textIndent: "0in",
                lineHeight: "100%",
                orphans: 0,
                widows: 0,
              }}
            >
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  By clicking on the “I ACCEPT” button (or similar), completing the registration process, or otherwise
                  accessing or using the Platform, or any portion thereof, you acknowledge and agree that: (1) you have
                  read, understand, and agree to be bound by this Agreement and any future amendments and additions to
                  this Agreement as published through the Platform; (2) you are of legal age in your jurisdiction of
                  residence to form a binding contract; and (3) you have the authority to enter into this Agreement (on
                  behalf of yourself personally, and as applicable, any entity that you represent for purposes of this
                  Agreement). The terms “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>you</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”, “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>your</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”, or “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>User</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ” refers to you, each visitor of the site, and the individual or legal entity, as applicable,
                  identified as the user when you registered on the website (including users who use Foody to find
                  content (“
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>Customers</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”) and users who create and post the recipes and other content (“
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>Recipe Content</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”) to the Platform (“
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>Creators</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ”)). If the individual entering into this Agreement or otherwise accessing or using the Platform is
                  doing so on behalf of, or within such individual’s capacity as a representative, agent, or employee of
                  an entity, such individual and such entity agree that: (i) the terms “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>you</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ” and “
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>your</b>
                </font>
              </font>
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  ” as used herein apply to such entity and such individual, and (ii) the individual entering into this
                  Agreement has the right, power, authority and capacity to enter into this Agreement on behalf of such
                  entity.
                </font>
              </font>
            </p>
            <p
              align="justify"
              style={{
                marginLeft: "0in",
                marginRight: "0in",
                textIndent: "0in",
                border: "none",
                padding: "0in",
                lineHeight: "100%",
                orphans: 2,
                widows: 2,
                pageBreakAfter: "avoid",
              }}
            >
              <font color="#000000">
                <font face="Lato-Regular, serif">
                  <font size={2} style={{ fontSize: "9pt" }}>
                    PLEASE NOTE THAT THIS AGREEMENT IS SUBJECT TO CHANGE BY FOODY IN ITS SOLE DISCRETION AT ANY TIME.
                    Foody reserves the right to modify this Agreement or its policies relating to the Platform at any
                    time, effective upon posting of an updated version of this Agreement. You should regularly review
                    this Agreement, as your continued use of the Platform after any such changes constitutes your
                    agreement to such changes.
                  </font>
                </font>
              </font>
            </p>
            <ol>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>HOW THE PLATFORM WORKS.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        Creators can post Recipe Content to the Platform, and Customers can search for and access the
                        Recipe Content. The Platform facilitates connections between Customers and Creators. Please
                        review our website{" "}
                      </font>
                    </font>
                  </font>
                  <a href="http://www.joinfoody.com/">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        www.joinfoody.com
                      </font>
                    </font>
                  </a>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        for more details on how the Platform works.
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b></b>
                      </font>
                    </font>
                  </font>
                </p>
              </li>
            </ol>
            <p
              align="justify"
              style={{
                marginLeft: "0in",
                marginRight: "0in",
                textIndent: "0in",
                marginBottom: "0.14in",
                lineHeight: "100%",
                orphans: 2,
                widows: 2,
              }}
            >
              <a name="_heading=h.gjdgxs" />
              <font face="Lato-Regular, serif">
                <font size={2} style={{ fontSize: "9pt" }}>
                  <b>
                    CREATORS ARE NOT EMPLOYEES, PARTNERS, REPRESENTATIVES, AGENTS, JOINT VENTURERS, OR FRANCHISEES OF
                    FOODY. FOODY DOES NOT EMPLOY OR RETAIN CREATORS. YOU HEREBY ACKNOWLEDGE THAT FOODY DOES NOT
                    SUPERVISE, DIRECT, CONTROL OR ACCEPT ANY RESPONSIBILITY FOR THE RECIPE CONTENT, BUT MAY MONITOR AND
                    FACILITATE CERTAIN ASPECTS OF INTERACTIONS FACILITATED THROUGH THE PLATFORM.
                  </b>
                </font>
              </font>
            </p>
            <ol start={2}>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <a name="_heading=h.30j0zll" />
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>USE OF THE PLATFORM</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>.</b>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        The Platform, and any parts thereof, are protected by copyright laws throughout the world.
                        Subject to this Agreement, Foody grants you the right to access and use the features and
                        functionality of the Platform, as well as a limited license to use the Platform to offer or
                        obtain access to Recipe Content. Unless otherwise specified by Foody in a separate license, your
                        right to use the Platform is subject to this Agreement.
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Updates and Modifications</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foody may from time to time develop patches, bug fixes, updates, upgrades and other
                            modifications to the Platform (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Updates</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”). These Updates may be automatically implemented without providing any additional notice
                            or receiving any additional consent. Under this Agreement, you consent to these automatic
                            updates. If you do not want such Updates, your exclusive remedy is to terminate your Account
                            (as defined below). If you do not terminate your Account, you will receive Updates
                            automatically. Your continued use of the Platform is your agreement to this Agreement with
                            respect to the Platform, including all Updates. Foody reserves the right to modify or
                            discontinue the Platform at any time (including by limiting or discontinuing certain
                            features of the Platform), temporarily or permanently, without notice to you. We will have
                            no liability on account of any change to the Platform or any suspension or termination of
                            your access to or use of the Platform.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.1fob9te" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Certain Restrictions</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            The rights granted to you in this Agreement are subject to the following restrictions: (a)
                            you shall not license, sell, rent, lease, transfer, assign, reproduce, distribute, host or
                            otherwise commercially exploit the Platform or any portion of the Platform; (b) you shall
                            not frame or use framing techniques to enclose any trademark, service mark, or logo
                            (including images, text, page layout or form) of Foody; (c) you shall not use any metatags
                            or other “hidden text” using Foody's name, service marks, or trademarks; (d) you shall not
                            modify, translate, adapt, merge, make derivative works of, disassemble, decompile, reverse
                            compile or reverse engineer any part of (i) the Platform, and with respect of Customer, (ii)
                            the Recipe Content, except to the extent the foregoing restrictions are expressly prohibited
                            by applicable law; (e) you shall not use any manual or automated software, devices or other
                            processes (including but not limited to spiders, robots, scrapers, crawlers, avatars, data
                            mining tools or the like) to “scrape” or download data from the Platform (except that we
                            grant the operators of public search engines revocable permission to use spiders to copy
                            materials from the website for the sole purpose of and solely to the extent necessary for
                            creating publicly available searchable indices of the materials, but not caches or archives
                            of such materials); (f) you shall not access the Platform to build a similar or competitive
                            website, application or service; (g) except as expressly stated herein, no part of the
                            Platform may be copied, reproduced, distributed, republished, downloaded, displayed, posted
                            or transmitted in any form or by any means; (h) you shall not remove or destroy any
                            copyright notices or other proprietary markings contained on or in the Platform; (i) you
                            shall not interfere with or attempt to interfere with the proper functioning of the Platform
                            or use the Platform in any way not expressly permitted by this Agreement; and (j) you shall
                            not attempt to harm our Platform, including but not limited to, by violating or attempting
                            to violate any related security features, introducing viruses, worms, or similar harmful
                            code into the Platform, or interfering or attempting to interfere with use of the Platform
                            by any other user, host or network, including by means of overloading, “flooding,”
                            “spamming,” “mail bombing”, or “crashing” the Platform. Any unauthorized use of the Platform
                            terminates the licenses granted by Foody pursuant to this Agreement.
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            &nbsp;
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Any future release, Update or other addition to the Platform shall be subject to the
                            Agreement. Foody, its suppliers and service providers reserve all rights not granted in the
                            Agreement. Any unauthorized use, or suspected unauthorized user, of the Platform terminates
                            the rights and licenses granted by Foody pursuant to the Agreement. You agree to indemnify
                            “Foody Parties” (as defined in Section 13 below) in the event of any claims against Foody
                            based on or arising from your violation of the foregoing.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>REGISTRATION.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.3znysh7" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Registering Your Account</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            In order to access the features of the Platform, including as a Customer or Creator, you may
                            be required to become a registered user on the Platform (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Account</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”). By registering your account with us and connecting with Stripe, you agree to be bound by
                            our Terms and the{" "}
                          </font>
                        </font>
                      </font>
                      <a href="https://stripe.com/connect-account/legal">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Stripe Connected Account Agreement
                          </font>
                        </font>
                      </a>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            .
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Registration Data</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            In registering an Account through the Platform, you agree to (a)&nbsp;provide true,
                            accurate, current and complete information about yourself as prompted by the registration
                            form (the “
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Registration Data</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”); and (b)&nbsp;maintain and promptly update the Registration Data to keep it true,
                            accurate, current and complete. You agree that you shall monitor your Account to restrict
                            use by minors, and you will accept full responsibility for any unauthorized use of the
                            Platform by minors. You may not share your Account or password with anyone, and you agree to
                            (x)&nbsp;notify Foody immediately of any unauthorized use of your password or any other
                            breach of security; and (y) exit from your Account at the end of each session. If you
                            provide any information that is untrue, inaccurate, not current or incomplete, or Foody has
                            reasonable grounds to suspect that such information is untrue, inaccurate, not current or
                            incomplete, Foody has the right to suspend or terminate your Account at any time for any
                            reason or for no reason and refuse any and all current or future use of the Platform (or any
                            portion thereof). You agree not to create an Account using a false identity or information,
                            or on behalf of someone other than yourself. You agree that you shall not have more than one
                            Account at any given time. You agree not to create an Account or use the Platform if you
                            have been previously removed by Foody, or if you have been previously banned from the
                            Platform.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Social Networking Site</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . If you access the Platform through a social network service (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>SNS</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”), as part of the functionality of the Platform, you may link your Account with a SNS, by
                            allowing Foody to access your SNS, as is permitted under the applicable terms and conditions
                            that govern your use of each SNS. You represent that you are entitled to grant Foody access
                            to your SNS account (including, for the purposes described herein) without breach by you of
                            any of the terms and conditions that govern your use of the applicable SNS. By granting
                            Foody access to any SNS accounts, you understand that Foody may access, make available and
                            store (if applicable) any information, data, text, software, music, sound, photographs,
                            graphics, video, messages, tags and/or other materials accessible through the Platform that
                            you have provided to and stored in your SNS account (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>SNS Content</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) so that it is available on and through the Platform. Unless otherwise specified in this
                            Agreement, all SNS Content shall be considered to be User Content (as defined below).
                            Depending on the SNS account you choose and subject to the privacy settings that you have
                            set in such SNS account, personally identifiable information that you post to your SNS
                            account may be available on and through the Platform.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Necessary Equipment</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            In order to participate in the Platform as a Creator, you must maintain ownership or
                            permission to license all Recipe Content you upload to the Platform. In order for all Users
                            to engage with the Platform, you must provide all equipment and software necessary to
                            connect to the Platform, including but not limited to, a mobile device that is suitable to
                            connect with and use the Platform. You are solely responsible for any fees for any
                            third-party platforms, Internet connection or mobile fees, that you incur when accessing the
                            Platform.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <a name="_Ref82002636" />
                  <a name="_heading=h.2et92p0" />
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>CREATOR TERMS.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                        pageBreakAfter: "auto",
                      }}
                    >
                      <a name="_Hlk81890119" />
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <font face="Lato-Regular, serif">
                          Foody shall have the right, but Foody maintains no obligation, to include Recipe Content
                          presented by Creator on the Platform. You acknowledge and agree that: (i) Foody in its sole
                          discretion will determine the Fee associated with the Recipe Content; (ii) Foody may offer
                          additional discounts and promotions in connection with Recipe Content on the Platform, at its
                          sole discretion and without notice to you, which initiatives may affect your earnings; and
                          (iii) the placement and ranking of Recipe Content in search results on the Foody Platform may
                          vary and depend on a variety of factors, such as Customer search parameters and preferences,
                          and based on other qualitative measures used by Foody in its discretion.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            As
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            an independent individual or business, you, as a Creator, maintain complete control over
                            your level of participation in the Platform, including: (a) deciding when to log into the
                            Platform and make Recipe Content available to Customers; (b) selecting the Recipe Content
                            you upload to the Platform; (c) not being restricted from using competitive services or
                            technology platforms (other than as set forth herein); (d) being permitted to maintain your
                            independent business without using the Platform; and (e) any opportunity for profit or loss
                            being dependent on the Recipe Content you post. You are not permitted to represent to any
                            third parties, including any Users of the Platform that you are an employee, contractor or
                            agent of Foody
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Neither this Agreement nor your performance under this Agreement shall create an
                            association, partnership, joint venture or relationship of principal and agent, master and
                            servant, or employer or employee, between Foody and you, or between Foody and your employees
                            and agents. You and Foody each agree that you and your employees and agents (if applicable)
                            will not receive any Foody-sponsored benefits from Foody where benefits include, but are not
                            limited to, paid vacation, sick leave, medical insurance and 401k participation. If you,
                            your employees or agents (if applicable), are reclassified by a state or federal agency or
                            court as Foody’s employee, you, and your employees or agents, as applicable, will become a
                            reclassified employee and will receive no benefits from Foody, except those mandated by
                            state or federal law, even if the terms of Foody’s benefit plans or programs in effect at
                            the time of such reclassification would otherwise render you, or your employees or agents as
                            eligible for such benefits. You acknowledge that it is your sole responsibility for
                            complying with all federal, state and local tax filing and payment obligations that pertain
                            to any remuneration received in connection with the Platform as processed by Foody in
                            connection with this Agreement, including your sole responsibility for all tax withholding,
                            Social Security, Worker’s Compensation Insurance, FICA, unemployment compensation, medical
                            insurance, life insurance, paid vacations, paid holidays, pensions and other obligations or
                            benefits. You acknowledge that Foody is not rendering legal, tax or investment advice, nor
                            is Foody a fiduciary of yours. Accordingly, you acknowledge that you may seek advice from an
                            appropriate professional to comply with any and all applicable federal, state and local laws
                            or ordinances.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>FEES AND PURCHASE TERMS.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Payment Terms for Creators</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            .
                          </font>
                        </font>
                      </font>
                    </p>
                    <ol type="i">
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                <b>Creator Payments</b>
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                . As Creator, you may be entitled to receive payment (“
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                <b>Creator Payment</b>
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                ”) in connection with the Recipe Content you upload to the Platform. To be eligible for
                                payment, (i) you must link a debit card or other method of accepting payment through our
                                payment processor; and (ii) the Recipe Content you make available on the Platform must
                                be purchased by Customers via the Platform. Creator Payments shall be payable at the
                                rates set forth on the Foody pricing webpage
                              </font>
                            </font>
                          </font>
                          <a href="https://joinfoody.notion.site/Foody-Frequently-Asked-Questions-e64cfc62a2124781a83a0807b954cb73">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                https://joinfoody.notion.site/Foody-Frequently-Asked-Questions-e64cfc62a2124781a83a0807b954cb73
                              </font>
                            </font>
                          </a>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                . Foody reserves the right to change the Creator Payment or its pricing model at any
                                time. Any such change to Creator Payments shall go into effect no earlier than thirty
                                (30) days after the change is posted to the Foody pricing webpage. Creator is solely
                                responsible for filing all tax returns and submitting all payments as required by any
                                federal, state, local, or foreign tax authority arising from the payment of the Creator
                                Payment to Creator under this Agreement and agrees to do so in a timely manner.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                <b>Payment Acceptance.</b>
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                As a Creator, you may be required to create an account to connect with our payment
                                processor Stripe. Payment processing services for Creators are provided by Stripe and
                                are subject to the{" "}
                              </font>
                            </font>
                          </font>
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              Stripe Connected Account Agreement
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                which includes the{" "}
                              </font>
                            </font>
                          </font>
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              Stripe Terms of Services
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                (collectively, the “
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                <b>Stripe Services Agreement</b>
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                ”). By agreeing to these Terms, you agree to be bound by the Stripe Services Agreement,
                                as the same may be modified by Stripe from time to time. As a condition of Foody
                                enabling payment processing services through Stripe, you agree to provide Foody with
                                accurate and complete information about you and your business, and you authorize Foody
                                to share it and transaction information related to your use of the payment processing
                                services provided by Stripe. You must keep your Stripe account information current in
                                order to receive payments from us.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Payment Terms for Customers</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                    </p>
                    <ol type="i">
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                <b>Fees</b>
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                . Customer agrees to pay all fees associated with Customer’s Account (collectively “
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                <b>Fees</b>
                              </font>
                            </font>
                          </font>
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                ”). Fees associated with your purchase of Recipe Content will be made available to you
                                at or before the time of purchase on our Platform. You, as a Customer, will be
                                responsible for paying any applicable taxes relating to your payments and will indemnify
                                and hold harmless Foody from any and all taxes, including sales tax, based on any
                                payments made by you via the Platform. Foody does not make any representation or render
                                any advice as to the potential tax implications of any payments made via the Platform,
                                and you should consult your tax professional with regard to the same. Except as
                                otherwise set forth herein or agreed to by Foody, all Fees paid by Customers are
                                non-refundable.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Third-Party Payment Method</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foody uses Stripe as the third-party service provider for payment services (e.g., card
                            acceptance and related services). By purchasing access to Recipe Content on the Platform,
                            you agree to be bound by the Stripe Privacy Policy: https://stripe.com/privacy, and hereby
                            consent and authorize Foody and Stripe to share any information and payment instructions you
                            provide with third-party service provider(s) to the minimum extent required to complete your
                            transactions. All information that you provide to us or to Stripe must be accurate, current,
                            and complete. By purchasing access to Recipe Content on the Platform, you authorize Foody to
                            charge your payment card (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Payment Method</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) in accordance with this Section 4 .
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            We may place a hold on your Payment Method, in which case you will be notified of such hold
                            at the time you initiate a transaction on the Platform.
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL RIGHT TO USE ANY PAYMENT METHOD USED TO
                            PAY ANY FEES.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Promotions</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Any promotions that provide premium access to the Platform, discounted purchases, or credits
                            toward your Account must be used within the specified time of the trial or promotion. At the
                            end of the specified period, your use of that Platform service will expire and any further
                            use of such service is prohibited unless you pay all applicable fees.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>CONTENT.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Types of Content</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . You acknowledge that all information supplied in and on the Platform (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Content</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) is the sole responsibility of the party from whom such Content originated. This means
                            that you, and not Foody, are entirely responsible for all Content (including photographs)
                            that you upload, post, e-mail, transmit or otherwise make available (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Make Available</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) through the Platform (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Your Content</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”), and that you and other Users, and not Foody, are similarly responsible for all Content
                            (including, without limitation, Recipe Content) that you and they Make Available through the
                            Platform (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>User Content</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”).
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>No Obligation to Pre-Screen Content</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . You acknowledge that Foody has no obligation to pre-screen Content (including, but not
                            limited to, User Content), although Foody reserves the right in its sole discretion to
                            pre-screen, refuse or remove any Content. By entering into the Agreement, you hereby provide
                            your irrevocable consent to such monitoring. You acknowledge and agree that you have no
                            expectation of privacy concerning the transmission of Your Content, including without
                            limitation email communications. In the event that Foody pre-screens, refuses or removes any
                            Content, you acknowledge that Foody will do so for Foody’s benefit, not yours. Without
                            limiting the foregoing, Foody shall have the right to remove any Content that violates the
                            Agreement or is otherwise objectionable.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 0,
                        widows: 0,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Storage</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . Unless expressly agreed to by Foody in writing elsewhere, Foody has no obligation to store
                            any of Your Content that you Make Available on the Platform. Foody has no responsibility or
                            liability for the deletion or accuracy of any Content, including Your Content; the failure
                            to store, transmit or receive transmission of Content; or the security, privacy, storage, or
                            transmission of other communications originating with or involving use of the Platform. You
                            may be able to restrict certain access to Your Content, in which case, you are solely
                            responsible for applying the appropriate level of access to Your Content. You agree that
                            Foody retains the right to create reasonable limits on Foody’s use and storage of the
                            Content, including Your Content, such as limits on file size, storage space, processing
                            capacity, and similar limits described on the Platform and as otherwise determined by Foody
                            in its sole discretion.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>OWNERSHIP AND INTELLECTUAL PROPERTY.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Platform</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            You agree that Foody and its suppliers own all rights, title and interest in the Platform,
                            and all parts thereof. You will not remove, alter or obscure any copyright, trademark,
                            service mark or other proprietary rights notices incorporated in or accompanying the
                            Platform.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.tyjcwt" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Trademarks</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foody will own and retain all right, title and interest in its trademarks, graphics, logos,
                            service marks, trade names and other brand elements (collectively, “
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Trademarks</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) used on or in connection with the Platform. Such Trademarks may not be used without
                            permission, including in connection with your or any third-party products or services. Other
                            trademarks, service marks and trade names that may appear on or in the Platform are the
                            property of their respective owners.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Your Content</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . Foody does not claim ownership of Your Content. However, when you as a User post or
                            publish Your Content on the Platform, you represent that you own and/or have a royalty-free,
                            perpetual, irrevocable, worldwide, non-exclusive right (including any moral rights) and
                            license to use, license, reproduce, modify, adapt, publish, translate, create derivative
                            works from, distribute, derive revenue or other remuneration from, and communicate to the
                            public, perform and display Your Content (in whole or in part) worldwide and/or to
                            incorporate it in other works in any form, media or technology now known or later developed,
                            for the full term of any worldwide intellectual property right that may exist in Your
                            Content.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>License to your Content</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . You grant Foody a fully paid, royalty-free, perpetual, irrevocable, worldwide,
                            non-exclusive right (including any moral rights) and license to use, host, display, publish,
                            license, distribute, reproduce, modify and adapt Your Content (in whole or in part) for the
                            purposes of operating, providing, developing and improving the Platform for you and to our
                            other Users; researching and developing new services; and otherwise in connection with the
                            platform, including without limitation for promotional or marketing purposes. You warrant
                            that the holder of any worldwide intellectual property right, including moral rights, in
                            Your Content, has completely and effectively waived all such rights and validly and
                            irrevocably granted to you the right to grant the license stated above. You agree that you,
                            not Foody, are responsible for all of Your Content that you Make Available on the Platform.
                            The Platform may contain User Content provided by other Users. Foody is not responsible for
                            and does not control User Content. Foody has no obligation to review or monitor, and does
                            not approve, endorse or make any representations or warranties with respect to, User
                            Content. You use all User Content and interact with other Users at your own risk.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Your Profile</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . Any Content posted by you in your profile may not contain nudity, violence, sexually
                            explicit, or offensive subject matter as determined by Foody in our sole discretion. You may
                            not post or submit for print services a photograph of another person without that person’s
                            permission.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Feedback</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            You agree that submission of any ideas, suggestions, documents, and/or proposals to Foody
                            through its suggestion, feedback, wiki, forum or similar pages or via email (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Feedback</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) is at your own risk and that Foody has no obligations (including without limitation
                            obligations of confidentiality) with respect to such Feedback. You represent and warrant
                            that you have all rights necessary to submit the Feedback. You hereby grant to Foody a fully
                            paid, royalty-free, perpetual, irrevocable, worldwide, non-exclusive, and fully
                            sublicensable right and license to use, reproduce, perform, display, distribute, adapt,
                            modify, re-format, create derivative works of, and otherwise commercially or
                            non-commercially exploit in any manner, any and all Feedback, and to sublicense the
                            foregoing rights, in connection with the operation and maintenance of the Platform. You also
                            acknowledge and agree that if and to the extent the material submitted by you identifies you
                            by name, likeness, voice or otherwise (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Name and Likeness</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”), the foregoing license granted by you will automatically be deemed to cover and extend
                            our use of your Name and Likeness in connection with our use of the material submitted by
                            you. In addition, you warrant that all so-called “moral rights” have been waived
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <i>.</i>
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>USER CONDUCT.</b>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        As a condition of use, you agree not to use the Platform for any purpose that is prohibited by
                        the Agreement or by applicable law. You shall not (and shall not permit any third-party) either
                        (a) to take any action or (b) Make Available any Content on or through the Platform that: (i)
                        infringes any patent, trademark, trade secret, copyright, right of publicity or other right of
                        any person or entity; (ii) you do not have a right to Make Available under any law or under
                        contractual or fiduciary relationships (such as inside information, proprietary and confidential
                        information learned or disclosed as part of employment relationships or under non-disclosure
                        agreements); (iii) is unlawful, threatening, abusive, harassing, defamatory, libelous,
                        deceptive, fraudulent, invasive of another's privacy, tortious, obscene, offensive, or profane;
                        (iv) constitutes unauthorized or unsolicited advertising, junk or bulk e-mail; (v) impersonates
                        any person or entity, including any employee or representative of Foody; or (vi) interferes with
                        or attempts to interfere with the proper functioning of the Platform or uses the Platform in any
                        way not expressly permitted by the Agreement.
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>THIRD-PARTY SERVICES.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Third-Party Services</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . The Platform may contain links to third-party websites (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Third-Party Websites</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”) and advertisements for third parties (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Third-Party Ads</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”). When you click on a link to a Third-Party Website or Third-Party Ad, we will not warn
                            you that you have left the Platform and are subject to the terms and conditions (including
                            privacy policies) of another website or destination. Such Third-Party Websites and
                            Third-Party Ads are not under the control of Foody. Foody is not responsible for any
                            Third-Party Websites or Third-Party Ads. Foody provides these Third-Party Websites and Third
                            Party Ads only as a convenience and does not review, approve, monitor, endorse, warrant, or
                            make any representations with respect to Third-Party Websites or Third-Party Ads, or their
                            products or services. You use all links in Third-Party Websites and Third-Party Ads at your
                            own risk. When you leave our website, our Agreement and policies no longer govern. You
                            should review applicable terms and policies, including privacy and data gathering practices,
                            of any Third-Party Websites, and should make whatever investigation you feel necessary or
                            appropriate before proceeding with any transaction with any third party.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Third-Party Content</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . The Platform may utilize or include content, software, and other copyrighted materials
                            provided by third parties (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Third-Party Content</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”). Your use of such Third-Party Content is governed by their respective terms and
                            conditions. By Accepting this Agreement, you are also accepting the additional terms and
                            conditions of the third parties. Foody expressly disclaims any and all warranties in
                            connection with Third-Party Content, and shall have no liability in connection therewith.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Open Source Software</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . The Platform may include or incorporate third- party software components that are
                            generally available free of charge under licenses granting recipients broad rights to copy,
                            modify, and distribute such components (“
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>Open Source Components</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            ”). Although the Platform is provided to you subject to this Agreement, nothing in this
                            Agreement prevents, restricts, or is intended to prevent or restrict you from obtaining such
                            Open Source Components under the applicable third-party licenses or to limit your use of
                            such Open Source Components thereunder.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT.</b>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        It is Foody’s policy to terminate membership privileges of any Users who repeatedly infringe
                        copyright upon prompt notification to Foody by the copyright owner or the copyright owner’s
                        legal agent. Without limiting the foregoing, if you believe that your work has been copied and
                        posted on or within the Platform in a way that constitutes copyright infringement, please
                        provide our Copyright Agent with the following information: (a) an electronic or physical
                        signature of the person authorized to act on behalf of the owner of the copyright interest; (b)
                        a description of the copyrighted work that you claim has been infringed; (c) a description of
                        the location on the Platform of the material that you claim is infringing; (d) your address,
                        telephone number and e-mail address; (e) a written statement by you that you have a good faith
                        belief that the disputed use is not authorized by the copyright owner, its agent or the law; and
                        (f) a statement by you, made under penalty of perjury, that the above information in your notice
                        is accurate and that you are the copyright owner or authorized to act on the copyright owner’s
                        behalf. Contact information for Foody’s Copyright Agent for notice of claims of copyright
                        infringement is as follows: [
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        Include name or title, and physical address of Copyright Agent
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        [Daniel Stitzel, CEO, 450 Townsend Street, San Francisco CA 94107 USA].
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>FOODY COMMUNICATIONS.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Generally</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . By entering into this Agreement or using the Platform you agree to receive communications,
                            including marketing and promotional communications, from us, via e-mail, or phone. You agree
                            that for all of our communications, message and data rates may apply.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Email Marketing Communications</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . If we send marketing or promotional email communications, you will have the ability to opt
                            out of receiving such communications by following the instructions in this section. YOU
                            ACKNOWLEDGE THAT YOU ARE NOT REQUIRED TO CONSENT TO RECEIVE PROMOTIONAL EMAILS AS A
                            CONDITION OF USING THE PLATFORM OR RELATED SERVICES. IF YOU WISH TO OPT OUT OF RECEIVING
                            PROMOTIONAL EMAIL COMMUNICATIONS FROM US, YOU CAN UNSUBSCRIBE FROM OUR PROMOTIONAL EMAIL
                            LIST BY FOLLOWING THE UNSUBSCRIBE OPTIONS IN THE PROMOTIONAL EMAIL ITSELF.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                        pageBreakAfter: "auto",
                      }}
                    >
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <b>Promotional SMS and/or Text Messages</b>
                          </font>
                        </font>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            . You may have the option to provide us with your contact information and sign up for an SMS
                            messaging service (a “
                          </font>
                        </font>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <b>SMS Messaging Service</b>
                          </font>
                        </font>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            ”) on the Platform. When you opt-in to an SMS Messaging Service, you may consent to receive
                            texts (including marketing texts) from us at the mobile number you’ve provided at opt-in,
                            including, but not limited to: communications concerning new and existing features of our
                            Platform, and communications concerning promotions run by us or our partners. If you opt in
                            to one of our SMS Messaging Services, we will send you an SMS message to confirm your sign
                            up. You can cancel the SMS Messaging Service at any time. Just text “STOP” to the telephone
                            number or short code we used to contact you. We may change any short code or telephone
                            number we use to operate our SMS service at any time. You acknowledge that any messages,
                            including any STOP or HELP requests, you send to a short code or telephone number we have
                            changed may not be received and we will not be responsible for honoring requests made in
                            such messages. IF YOU WISH TO OPT OUT OF PROMOTIONAL CALLS OR TEXTS, YOU MAY TEXT “END” TO
                            THE TELEPHONE OR SHORT CODE WE USED TO CONTACT YOU. YOU ACKNOWLEDGE THAT YOU ARE NOT
                            REQUIRED TO CONSENT TO RECEIVE PROMOTIONAL TEXTS OR CALLS AS A CONDITION OF USING THE
                            PLATFORM OR RELATED SERVICES.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Electronic Communications</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . The communications between you and Foody may take place via electronic means, whether you
                            visit the Platform or send us e-mails, or whether we post notices on the Platform, or
                            communicate with you via e-mail or text message. For contractual purposes, you (i) consent
                            to receive communications from Foody in an electronic form; and (ii) agree that all terms
                            and conditions, agreements, notices, disclosures, and other communications that Foody
                            provides to you electronically satisfy any legal requirement that such communications would
                            satisfy if it were to be in writing. The foregoing does not affect your statutory rights.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>REMEDIES.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Violations</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . If Foody becomes aware of any possible violations by you of the Agreement, Foody reserves
                            the right to investigate such violations. If, as a result of the investigation, Foody
                            believes that criminal activity has occurred, Foody reserves the right to refer the matter
                            to, and to cooperate with, any and all applicable legal authorities. Foody is entitled,
                            except to the extent prohibited by applicable law, to disclose any information or materials
                            on or in the Platform, including Your Content, in Foody’s possession in connection with your
                            use of the Platform, to (a) comply with applicable laws, legal process or governmental
                            request, (b) enforce the Agreement, (c) respond to any claims that Your Content violates the
                            rights of third parties, (d) respond to your requests for customer service, or (e) protect
                            the rights, property or personal safety of Foody, its Users and Registered Users or the
                            public, and all enforcement or other government officials, as Foody in its sole discretion
                            believes to be necessary or appropriate.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Breach</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . In the event that Foody determines, in its sole discretion, that you have breached any
                            portion of the Agreement, or have otherwise demonstrated conduct inappropriate for the
                            Platform, Foody reserves the right to:
                          </font>
                        </font>
                      </font>
                    </p>
                    <ol type="i">
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                Delete any of Your Content provided by you or your agent(s) to the Platform;
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                Warn you via e-mail (to any e-mail address you have provided to Foody) that you have
                                violated the Agreement;
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                Discontinue your registration with the Platform;
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                Discontinue your access to the Platform;
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                Notify and/or send Content to and/or fully cooperate with the proper law enforcement
                                authorities for further action; and/or
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                Pursue any other action which Foody deems to be appropriate.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <a name="_Ref82001086" />
                  <a name="_heading=h.3dy6vkm" />
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>INDEMNIFICATION</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>.</b>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        You agree to indemnify and hold harmless Foody, its parents, subsidiaries, affiliates, officers,
                        employees, agents, partners and licensors (collectively, the “
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>Foody Parties</b>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        ”) from any losses, costs, liabilities and expenses (including reasonable attorneys’ fees)
                        relating to or arising out of: (a)&nbsp;&nbsp;your use of, or inability to use, the Platform or
                        any Recipe Content; (b)&nbsp;your violation of the Agreement; (c)&nbsp;your violation of any
                        rights of another party, including any other Users; and (d)&nbsp;your violation of any
                        applicable laws, rules or regulations. Foody reserves the right, at its own cost, to assume the
                        exclusive defense and control of any matter otherwise subject to indemnification by you, in
                        which event you will fully cooperate with Foody in asserting any available defenses. This
                        provision does not require you to indemnify any of Foody Parties for any unconscionable
                        commercial practice by such party or for such party’s fraud, deception, false promise,
                        misrepresentation or concealment, suppression or omission of any material fact in connection
                        with the Platform provided hereunder. You agree that the provisions in this section will survive
                        any termination of your Account, the Agreement or your access to the Platform.
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>DISCLAIMER OF WARRANTIES AND CONDITIONS</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foody does not create the Recipe Content, and has no responsibility or liability for the
                            acts or omissions of, or Recipe Content provided by, any Creator on the Platform. Creators
                            are solely responsible for their Recipe Content and any other information they make
                            available on the Platform. YOU AGREE THAT FOODY HAS NO RESPONSIBILITY OR LIABILITY TO YOU
                            FOR ANY RECIPE CONTENT OTHER THAN AS EXPRESSLY SET FORTH IN THIS AGREEMENT. ANY RECIPE
                            CONTENT IS PROVIDED BY CREATORS AND NOT BY FOODY.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>As Is</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . YOU EXPRESSLY UNDERSTAND AND AGREE THAT TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOUR
                            USE OF THE PLATFORM AND THE RECIPE CONTENT IS AT YOUR SOLE RISK, AND THE PLATFORM IS
                            PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITH ALL FAULTS. FOODY PARTIES EXPRESSLY
                            DISCLAIM ALL WARRANTIES, REPRESENTATIONS, AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR
                            IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OR CONDITIONS OF
                            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT ARISING FROM USE OF
                            THE PLATFORM.
                          </font>
                        </font>
                      </font>
                    </p>
                    <ol type="i">
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                FOODY PARTIES MAKE NO WARRANTY, REPRESENTATION OR CONDITION THAT: (1) THE PLATFORM OR
                                RECIPE CONTENT WILL MEET YOUR EXPECTATIONS OR REQUIREMENTS; (2) THE INFORMATION,
                                CONTENT, AND DATA ON THE PLATFORM IS ACCURATE, COMPLETE, OR CURRENT; (3) YOUR USE OF THE
                                PLATFORM WILL BE UNINTERRUPTED, TIMELY, SECURE OR ERROR-FREE; (4) ANY ERRORS ON THE
                                PLATFORM WILL BE CORRECTED; (5) YOUR USE OF THE PLATFORM WILL NOT EXPOSE YOUR HARDWARE
                                OR NETWORKS TO ADDITIONAL SECURITY RISK; AND (6) THE PLATFORM WILL BE COMPATIBLE WITH
                                YOUR DEVICES.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                ANY CONTENT, INCLUDING RECIPE CONTENT, ACCESSED THROUGH THE PLATFORM IS ACCESSED AT YOUR
                                OWN RISK, AND YOU SHALL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY,
                                INCLUDING, BUT NOT LIMITED TO, PERSONAL PROPERTY, YOUR COMPUTER SYSTEM AND ANY DEVICE
                                YOU USE TO ACCESS THE PLATFORM, OR ANY OTHER LOSS THAT RESULTS FROM ACCESSING SUCH
                                CONTENT.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                      <li>
                        <p
                          align="justify"
                          style={{
                            marginRight: "0in",
                            textIndent: "0in",
                            border: "none",
                            padding: "0in",
                            lineHeight: "100%",
                            orphans: 2,
                            widows: 2,
                          }}
                        >
                          <font color="#000000">
                            <font face="Lato-Regular, serif">
                              <font size={2} style={{ fontSize: "9pt" }}>
                                THE PLATFORM MAY BE SUBJECT TO DELAYS, CANCELLATIONS AND OTHER DISRUPTIONS. FOODY MAKES
                                NO WARRANTY, REPRESENTATION OR CONDITION WITH RESPECT TO THE PLATFORM, INCLUDING BUT NOT
                                LIMITED TO, THE QUALITY, EFFECTIVENESS, REPUTATION AND OTHER CHARACTERISTICS OF
                                PLATFORM.
                              </font>
                            </font>
                          </font>
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                        pageBreakAfter: "auto",
                      }}
                    >
                      <a name="_heading=h.1t3h5sf" />
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <u>
                              <b>Food Preparation and Allergens</b>
                            </u>
                          </font>
                        </font>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            . YOU ARE SOLELY RESPONSIBLE FOR, AND ASSUME ALL RISKS RELATED TO, THE SAFE AND PROPER
                            HANDLING, WASHING, PREPARATION, STORAGE, COOKING, USE AND CONSUMPTION OF ANY FOOD PREPARED
                            IN CONNECTION WITH THE RECIPE CONTENT PROVIDED BY CREATORS HEREIN. AS DETERMINED BY THE US
                            FOOD AND DRUG ADMINISTRATION, THE EIGHT MAJOR ALLERGENS INCLUDE WHEAT, EGG, SOY, MILK,
                            TREENUTS, PEANUTS, FISH, AND SHELLFISH. YOU UNDERSTAND THAT RECIPE CONTENT MAY CONTAIN SOME
                            OR ALL OF THE EIGHT MAJOR ALLERGENS LISTED. YOU ARE ALSO SOLELY RESPONSIBLE FOR KNOWING
                            ABOUT ANY FOOD ALLERGIES YOU MAY HAVE AND VERIFYING THE RECIPE CONTENT AND ANY ASSOCIATED
                            INGREDIENTS BEFORE HANDLING, PREPARING, USING OR CONSUMING FOOD IN CONNECTION WITH THE
                            RECIPE CONTENT. FOODY DOES NOT REPRESENT OR WARRANT THAT THE NUTRITION FACTS, AND OTHER
                            RECIPE CONTENT INFORMATION ON OUR PLATFORM IS ACCURATE OR COMPLETE SINCE THIS INFORMATION IS
                            PROVIDED BY THE CREATOR.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>No Liability for Conduct of Third Parties</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . YOU ACKNOWLEDGE AND AGREE THAT FOODY PARTIES ARE NOT LIABLE, AND YOU AGREE NOT TO SEEK TO
                            HOLD FOODY PARTIES LIABLE, FOR THE CONDUCT OF THIRD PARTIES, INCLUDING OTHER USERS OF THE
                            PLATFORM OR OPERATORS OF EXTERNAL SITES, AND THAT THE RISK OF INJURY FROM SUCH THIRD PARTIES
                            RESTS ENTIRELY WITH YOU.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>LIMITATION OF LIABILITY; INSURANCE.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <span style={{ fontVariant: "small-caps" }}>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              <u>
                                <b>DISCLAIMER OF CERTAIN DAMAGES</b>
                              </u>
                            </font>
                          </font>
                        </font>
                      </span>
                      <span style={{ fontVariant: "small-caps" }}>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              . TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL FOODY PARTIES BE
                              LIABLE FOR ANY LOSS OF PROFITS OR REVENUE OR FOR INDIRECT, INCIDENTAL, SPECIAL OR
                              CONSEQUENTIAL DAMAGES, OR DAMAGES OR COSTS DUE TO LOSS OF DATA, PRODUCTION, OR USE,
                              BUSINESS INTERRUPTION OR PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, WHETHER OR NOT FOODY
                              HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                            </font>
                          </font>
                        </font>
                      </span>
                      <span style={{ fontVariant: "small-caps" }}>
                        <font color="#222222">
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              &nbsp;
                            </font>
                          </font>
                        </font>
                      </span>
                      <span style={{ fontVariant: "small-caps" }}>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              FOODY PARTIES DO NOT GUARANTY THE QUALITY OR SUITABILITY, OF ANY RECIPE CONTENT, AND EACH
                              USER OF THE PLATFORM AGREES THAT THE ENTIRE RISK ARISING OUT OF HIS/HER USE OF THE
                              PLATFORM, AND RECIPE CONTENT REMAINS SOLELY WITH SUCH USER, TO THE MAXIMUM EXTENT
                              PERMITTED UNDER APPLICABLE LAW. FOODY WILL NOT BE LIABLE FOR ANY CLAIM, INJURY OR DAMAGE
                              ARISING IN CONNECTION WITH THE PLATFORM OR ANY RECIPE CONTENT.
                            </font>
                          </font>
                        </font>
                      </span>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Cap on Liability</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . UNDER NO CIRCUMSTANCES WILL FOODY PARTIES BE LIABLE TO YOU FOR MORE THAN THE GREATER OF
                            (A) THE TOTAL AMOUNT PAID OR PAYABLE TO FOODY DURING THE ONE-MONTH PERIOD PRIOR TO THE ACT,
                            OMISSION OR OCCURRENCE GIVING RISE TO SUCH LIABILITY; OR (B) ONE HUNDRED DOLLARS ($100).
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            THE LAWS OF SOME STATES DO NOT ALLOW FOR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF
                            THESE LAWS APPLY TO YOU, SOME OR ALL OF THE LIMITATIONS SET FORTH IN THIS SUBSECTION MAY NOT
                            APPLY TO YOU AND YOU MIGHT HAVE OTHER RIGHTS.&nbsp;
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Basis of the Bargain</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            . The limitations of damages set forth above are fundamental elements of the basis of the
                            bargain between Foody and you. Notwithstanding the foregoing, the limitations and disclaimer
                            in this section do not purport to limit liability or alter a User’s rights as a consumer
                            that cannot be excluded under applicable law.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <a name="_heading=h.4d34og8" />
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>RELEASE.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        You hereby release Foody Parties from claims, demands, any and all losses, damages, rights, and
                        actions of any kind, including personal injuries, death, and property damage, that is either
                        directly or indirectly related to or arises from your use of the Platform or Recipe Content,
                        including but not limited to, any interactions with or conduct of other Users of the Platform,
                        or third-party websites of any kind arising in connection with or as a result of the Agreement
                        or your use of Platform. Should you, as a Customer, have a dispute with respect to the Platform
                        or any Recipe Content, you may address such dispute with Foody, but the Creator retains sole
                        responsibility for issues arising in connection with Recipe Content. You, as a Customer, hereby
                        agree to release Foody Parties from any losses, damages, rights, and actions of any kind,
                        including personal injuries, death, and property damage that is either directly or indirectly
                        related to or arises from or in any way connected with such disputes and your dealings with
                        Creators.
                      </font>
                    </font>
                  </font>
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          IF YOU ARE A CALIFORNIA RESIDENT, YOU HEREBY WAIVE CALIFORNIA CIVIL CODE SECTION 1542, WHICH
                          STATES, “A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR
                          SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH, IF KNOWN BY HIM
                          MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR.”
                        </font>
                      </font>
                    </font>
                  </span>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>TERMINATION AND DEACTIVATION</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.2s8eyo1" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Termination of Account</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            This Agreement will remain in full force and effect until your Account is terminated as
                            provided herein. You may delete your Account at any time for any reason through the settings
                            in your Account on the Platform. Foody may terminate or suspend your Account if (a)&nbsp;you
                            are in breach of the Agreement; (b)&nbsp;if Foody decides in its sole discretion to stop
                            facilitating the provision of the applicable Platform or Recipe Content; or (c)&nbsp;for any
                            or no reason, without giving you notice. You understand that any termination of this
                            Agreement and your Account may involve deletion of your Account information from our live
                            databases and all the information stored for such Account. Foody will not have any liability
                            whatsoever to you for any termination or suspension of your Account or related deletion of
                            your information.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Effect of Termination or Deactivation</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Deactivation includes removal of your access to the Platform and barring of further use of
                            the Platform. Upon Deactivation of the Platform, your right to use such Platform will
                            automatically terminate immediately. Foody will not have any liability to you for any
                            suspension or termination. All provisions of the Agreement which by their nature should
                            survive, shall survive termination of the Agreement or the Platform, including without
                            limitation, ownership provisions, warranty disclaimers, indemnification, and limitation of
                            liability.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <a name="_heading=h.17dp8vu" />
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>INTERNATIONAL USE</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>.</b>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        The Platform may be accessed from countries around the world and may contain references to
                        services and content that are not available in your state or country. These references do not
                        imply that Foody intends to announce such services and content in your state or country. The
                        Platform is controlled and offered by Foody from its facilities in cities and states where it
                        chooses to operate in the United States of America. Foody makes no representations that the
                        Platform is appropriate or available for use in other locations. Those who access or use the
                        Platform from other states or countries do so at their own volition and are responsible for
                        compliance with local law.
                      </font>
                    </font>
                  </font>
                </p>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                  }}
                >
                  <a name="_Ref81991869" />
                  <a name="_heading=h.3rdcrjn" />
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>ARBITRATION AGREEMENT.</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>
                          Please read the following arbitration agreement in this section (“Arbitration Agreement”)
                          carefully. It requires users to arbitrate disputes with Foody and limits the manner in which
                          you can seek relief from us.
                        </b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <a name="_Ref82005813" />
                      <a name="_heading=h.26in1rg" />
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Applicability of Arbitration Agreement</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <i>.</i>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          You agree that any dispute, claim, or request for relief relating in any way to your access or
                          use of the Platform, to any Recipe Content accessed through, or provided to, the Platform, or
                          to any aspect of your relationship with Foody, will be resolved by binding arbitration, rather
                          than in court, except that (a) you may assert claims or seek relief in small claims court if
                          your claims qualify; and (b) you or Foody may seek equitable relief in court for infringement
                          or other misuse of intellectual property rights (such as trademarks, trade dress, domain
                          names, trade secrets, copyrights, and patents). This Arbitration Agreement shall apply,
                          without limitation, to all disputes or claims and requests for relief that arose or were
                          asserted before the effective date of this Agreement or any prior version of this Agreement.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Arbitration Rules and Forum</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <i>.</i>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          The Federal Arbitration Act governs the interpretation and enforcement of this Arbitration
                          Agreement. To begin an arbitration proceeding, you must send a letter requesting arbitration
                          and describing your dispute or claim or request for relief to our registered agent Legalinc
                          Corporate Services Inc., 651 N Broad ST Suite 206, Middletown, DE 19709. The arbitration will
                          be conducted by JAMS, an established alternative dispute resolution provider.&nbsp;Disputes
                          involving claims, counterclaims, or request for relief under $250,000, not inclusive of
                          attorneys’ fees and interest, shall be subject to JAMS’s most current version of the
                          Streamlined Arbitration Rules and procedures available at
                          http://www.jamsadr.com/rules-streamlined-arbitration/; all other disputes shall be subject to
                          JAMS’s most current version of the Comprehensive Arbitration Rules and Procedures, available
                          at http://www.jamsadr.com/rules-comprehensive-arbitration/. JAMS’s rules are also available at
                          www.jamsadr.com or by calling JAMS at 800-352-5267. If JAMS is not available to arbitrate, the
                          parties will select an alternative arbitral forum. If the arbitrator finds that you cannot
                          afford to pay JAMS’s filing, administrative, hearing and/or other fees and cannot obtain a
                          waiver from JAMS, Foody will pay them for you. In addition, Foody will reimburse all such
                          JAMS’s filing, administrative, hearing and/or other fees for disputes, claims, or requests for
                          relief totaling less than $10,000 unless the arbitrator determines the claims are frivolous.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          You may choose to have the arbitration conducted by telephone, based on written submissions,
                          or in person in the country where you live or at another mutually agreed location. Any
                          judgment on the award rendered by the arbitrator may be entered in any court of competent
                          jurisdiction.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Authority of Arbitrator</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          .&nbsp;The arbitrator shall have exclusive authority to (a) determine the scope and
                          enforceability of this Arbitration Agreement and (b) resolve any dispute related to the
                          interpretation, applicability, enforceability or formation of this Arbitration Agreement
                          including, but not limited to, any assertion that all or any part of this Arbitration
                          Agreement is void or voidable. The arbitration will decide the rights and liabilities, if any,
                          of you and Foody. The arbitration proceeding will not be consolidated with any other matters
                          or joined with any other cases or parties.&nbsp;The arbitrator shall have the authority to
                          grant motions dispositive of all or part of any claim. The arbitrator shall have the authority
                          to award monetary damages and to grant any non-monetary remedy or relief available to an
                          individual under applicable law, the arbitral forum’s rules, and the Agreement (including the
                          Arbitration Agreement). The arbitrator shall issue a written award and statement of decision
                          describing the essential findings and conclusions on which the award is based, including the
                          calculation of any damages awarded.&nbsp;The arbitrator has the same authority to award relief
                          on an individual basis that a judge in a court of law would have.&nbsp;The award of the
                          arbitrator is final and binding upon you and us.&nbsp;
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <a name="_Ref82005843" />
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Waiver of Jury Trial</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          .&nbsp;YOU AND FOODY HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO SUE IN COURT AND
                          HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY. You and Foody are instead electing that all
                          disputes, claims, or requests for relief shall be resolved by arbitration under this
                          Arbitration Agreement, except as specified in Section 19.1 (Application of Arbitration
                          Agreement) above.&nbsp;An arbitrator can award on an individual basis the same damages and
                          relief as a court and must follow this Agreement as a court would. However, there is no judge
                          or jury in arbitration, and court review of an arbitration award is subject to very limited
                          review.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Waiver of Class or Other Non-Individualized Relief</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          .&nbsp;ALL DISPUTES, CLAIMS, AND REQUESTS FOR RELIEF WITHIN THE SCOPE OF THIS ARBITRATION
                          AGREEMENT MUST BE ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS OR COLLECTIVE BASIS,
                          ONLY INDIVIDUAL RELIEF IS AVAILABLE, AND CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT BE
                          ARBITRATED OR CONSOLIDATED WITH THOSE OF ANY OTHER CUSTOMER OR USER. If a decision is issued
                          stating that applicable law precludes enforcement of any of this section’s limitations as to a
                          given dispute, claim, or request for relief, then such aspect must be severed from the
                          arbitration and brought into the State or Federal Courts located in the State of New York. All
                          other disputes, claims, or requests for relief shall be arbitrated.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>30-Day Right to Opt Out</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          . You have the right to opt out of the provisions of this Arbitration Agreement by sending
                          written notice of your decision to opt out to support@joinfoody.com within thirty (30) days
                          after first becoming subject to this Arbitration Agreement. Your notice must include your name
                          and address, your Foody username (if any), the email address you used to set up your Foody
                          account (if you have one), and an unequivocal statement that you want to opt out of this
                          Arbitration Agreement. If you opt out of this Arbitration Agreement, all other parts of this
                          Agreement will continue to apply to you. Opting out of this Arbitration Agreement has no
                          effect on any other arbitration agreements that you may currently have, or may enter in the
                          future, with us.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Severability</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <i>.</i>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          Except as provided in Section 19.5 (Waiver of Jury Trial), if any part or parts of this
                          Arbitration Agreement are found under the law to be invalid or unenforceable, then such
                          specific part or parts shall be of no force and effect and shall{" "}
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          be severed and the remainder of the Arbitration Agreement shall continue in full force and
                          effect.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{ marginRight: "0in", textIndent: "0in", lineHeight: "100%", orphans: 2, widows: 2 }}
                    >
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>Survival of Agreement</b>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <i>.</i>
                        </font>
                      </font>
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          This Arbitration Agreement will survive the termination of your relationship with Foody.
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                        pageBreakAfter: "auto",
                      }}
                    >
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <font face="Lato-Regular, serif">
                          <b>Modification</b>
                        </font>
                        <font face="Lato-Regular, serif">
                          . Notwithstanding any provision in this Agreement to the contrary, we agree that if Foody
                          makes any future material change to this Arbitration Agreement, you may reject that change
                          within thirty (30) days of such change becoming effective by writing Foody at the following
                          address:{" "}
                        </font>
                        <font face="Lato-Regular, serif">
                          Legalinc Corporate Services Inc., 651 N Broad ST Suite 206, Middletown, DE 19709.
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p
                  align="justify"
                  style={{
                    marginRight: "0in",
                    textIndent: "0in",
                    border: "none",
                    padding: "0in",
                    lineHeight: "100%",
                    orphans: 2,
                    widows: 2,
                    pageBreakAfter: "avoid",
                  }}
                >
                  <span style={{ fontVariant: "small-caps" }}>
                    <font color="#000000">
                      <font face="Lato-Regular, serif">
                        <font size={2} style={{ fontSize: "9pt" }}>
                          <b>GENERAL PROVISIONS</b>
                        </font>
                      </font>
                    </font>
                  </span>
                  <font color="#000000">
                    <font face="Lato-Regular, serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>.</b>
                      </font>
                    </font>
                  </font>
                </p>
                <ol>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.lnxbz9" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Assignment</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            The Agreement, and your rights and obligations hereunder, may not be assigned,
                            subcontracted, delegated or otherwise transferred by you without Foody’s prior written
                            consent, and any attempted assignment, subcontract, delegation, or transfer in violation of
                            the foregoing will be null and void. Foody shall have the right to freely assign this
                            Agreement, in whole or in part, without your prior consent.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Force Majeure</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foody shall not be liable for any delay or failure to perform resulting from causes outside
                            its reasonable control, including, but not limited to, acts of God, war, terrorism, riots,
                            embargos, acts of civil or military authorities, fire, floods, accidents, pandemics,
                            epidemics, strikes or shortages of transportation facilities, fuel, energy, labor or
                            materials.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Questions, Complaints, Claims</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            If you have any questions, complaints or claims with respect to the Platform, please contact
                            us at: support@joinfoody.com. We will do our best to address your concerns. If you feel that
                            your concerns have been addressed incompletely, we invite you to let us know for further
                            investigation.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_Ref82006202" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Exclusive Venue</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            To the extent the parties are permitted under this Agreement to initiate litigation in a
                            court, or in the event this Section 20.4 is held to be unenforceable for any reason, both
                            you and{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foody
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            agree that all claims and disputes arising out of or relating to the Agreement will be
                            litigated exclusively in the state or federal courts located in California.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.35nkun2" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Governing Law</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <span style={{ fontVariant: "small-caps" }}>
                        <font color="#000000">
                          <font face="Lato-Regular, serif">
                            <font size={2} style={{ fontSize: "9pt" }}>
                              THE AGREEMENT AND ANY ACTION RELATED THERETO WILL BE GOVERNED AND INTERPRETED BY AND UNDER
                              THE LAWS OF THE STATE OF CALIFORNIA, CONSISTENT WITH THE FEDERAL ARBITRATION ACT, WITHOUT
                              GIVING EFFECT TO ANY PRINCIPLES THAT PROVIDE FOR THE APPLICATION OF THE LAW OF ANOTHER
                              JURISDICTION. THE UNITED NATIONS CONVENTION ON CONTRACTS FOR THE INTERNATIONAL SALE OF
                              GOODS DOES NOT APPLY TO THIS AGREEMENT.
                            </font>
                          </font>
                        </font>
                      </span>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.1ksv4uv" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Notice</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Where Foody requires that you provide an e-mail address, you are responsible for providing
                            Foody with your most current e-mail address. In the event that the last e-mail address you
                            provided to Foody is not valid, or for any reason is not capable of delivering to you any
                            notices required/ permitted by this Agreement, Foody’ dispatch of the e-mail containing such
                            notice will nonetheless constitute effective notice. You may give notice to Foody at the
                            following address
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            : support@joinfoody.com;{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Foodie Worldwide, Inc. 450 Townsend Street, San Francisco CA 94107 USA.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.44sinio" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Waiver</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Any waiver or failure to enforce any provision of this Agreement on one occasion will not be
                            deemed a waiver of any other provision or of such provision on any other occasion.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Severability</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            If any portion of this Agreement is held invalid or unenforceable, that portion shall be
                            construed in a manner to reflect, as nearly as possible, the original intention of the
                            parties, and the remaining portions shall remain in full force and effect.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Export Control</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            You may not use, export, import, or transfer the{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Platform
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            except as authorized by U.S. law, the laws of the jurisdiction in which you obtained the{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Platform
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            , and any other applicable laws. In particular, but without limitation, the{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Platform
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            may not be exported or re-exported (a)&nbsp;into any United States embargoed countries; or
                            (b)&nbsp;to anyone on the U.S. Treasury Department’s list of Specially Designated Nationals
                            or the U.S. Department of Commerce’s Denied Person’s List or Entity List. By using the{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Platform
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            , you represent and warrant that (i)&nbsp;you are not located in a country that is subject
                            to a U.S. Government embargo, or that has been designated by the U.S. Government as a
                            “terrorist supporting” country; and (ii)&nbsp;you are not listed on any U.S. Government list
                            of prohibited or restricted parties. You also will not use the{" "}
                          </font>
                        </font>
                      </font>
                      <font color="#222222">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            Platform
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            for any purpose prohibited by U.S. law, including the development, design, manufacture or
                            production of missiles, nuclear, chemical or biological weapons. You acknowledge and agree
                            that products, services or technology provided by Foody are subject to the export control
                            laws and regulations of the United States. You shall comply with these laws and regulations
                            and shall not, without prior U.S. government authorization, export, re-export, or transfer
                            Foody products, services or technology, either directly or indirectly, to any country in
                            violation of such laws and regulations.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Consumer Complaints</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            In accordance with California Civil Code §1789.3, you may report complaints to the Complaint
                            Assistance Unit of the Division of Consumer Services of the California Department of
                            Consumer Affairs by contacting them in writing at 400 R Street, Sacramento, CA 95814, or by
                            telephone at (800) 952-5210.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                  <li>
                    <p
                      align="justify"
                      style={{
                        marginRight: "0in",
                        textIndent: "0in",
                        border: "none",
                        padding: "0in",
                        lineHeight: "100%",
                        orphans: 2,
                        widows: 2,
                      }}
                    >
                      <a name="_heading=h.2jxsxqh" />
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <u>
                              <b>Entire Agreement</b>
                            </u>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            <b>.</b>
                          </font>
                        </font>
                      </font>
                      <font color="#000000">
                        <font face="Lato-Regular, serif">
                          <font size={2} style={{ fontSize: "9pt" }}>
                            This Agreement is the final, complete and exclusive agreement of the parties with respect to
                            the subject matter hereof and supersedes and merges all prior discussions between the
                            parties with respect to such subject matter.
                          </font>
                        </font>
                      </font>
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
            <p
              style={{
                marginLeft: "0in",
                textIndent: "0in",
                marginBottom: "0.14in",
                lineHeight: "83%",
                orphans: 2,
                widows: 2,
              }}
            >
              <br />
              <br />
            </p>
            <p
              style={{
                marginLeft: "0in",
                textIndent: "0in",
                marginBottom: "0.14in",
                lineHeight: "83%",
                orphans: 2,
                widows: 2,
              }}
            >
              <br />
              <br />
            </p>
          </div>
        </PrivacyContent>
      </PrivacyWrapper>
    </>
  );
};

export default TermsOfServicePage;
